import QuickJobsApi from './quickjobs-api';

const env = {
  url: process.env.REACT_APP_API_URL,
  key: process.env.REACT_APP_API_KEY,
  secret: process.env.REACT_APP_API_SECRET,
};

if (!env.url || !env.key || !env.secret) {
  throw new Error('Missing one of the required API params.');
}

export const api = new QuickJobsApi(env.url, env.key, env.secret);



// WEBPACK FOOTER //
// ./src/libs/index.ts